export const imageOverlayStyle = ({ loading, token }) => ({
  gridColumn: 1,
  gridRow: 1,
  boxSizing: 'border-box',
  display: 'flex',
  justify: 'center',
  alignItems: 'center',
  width: 128,
  position: 'relative',
  zIndex: 1,
  opacity: 0.4,
  borderRadius: '5%',
  backgroundColor: token.colorBgMask,
  cursor: loading ? 'not-allowed' : 'pointer'
})
